<template>
  <portfolio-allocation-component
    v-if="data.group_name === 'Alocação por estratégia'"
    :data="data"
  />
  <div v-else>
    <param-group-component :group="data" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {
    FormTooltip: () => import("../form/form-tooltip.component"),
    PortfolioAllocationComponent: () =>
      import("./portfolio-allocation.component.vue"),
    ParamGroupComponent: () => import("./portfolio-param-group.component.vue"),
  },

  props: {
    data: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters({
      info: "investment/getParametersInfo",
      section_index: "investment/getSectionIndex",
    }),
  },
};
</script>

<style></style>
